export default __webpack_public_path__ + "static/media/menu6.74bc392e.jpeg";